import texts from '../contributor.texts'

class Step1Controller {
    constructor($scope, $state, SharedMoments) {
        this.name = 'step1'

        this.$scope = $scope
        this.$state = $state
        this.SharedMoments = SharedMoments
    }

    $onInit() {
        this.render()

        this.watchLanguage()
    }

    render() {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            BEEN_IN_GEORGIA,
            POSTS_ANALYZED,
            USERNAME_PLACEHOLDER,
            CHECK,
            BEAR_IN_MIND,
            NOT_FOUND,
            CLOSE
        } = texts[this.language]

        this.beenInGeorgia = BEEN_IN_GEORGIA
        this.postsAnalyzed = POSTS_ANALYZED
        this.usernamePlaceholder = USERNAME_PLACEHOLDER
        this.check = CHECK
        this.bearInMind = BEAR_IN_MIND
        this.notFoundText = NOT_FOUND
        this.closeText = CLOSE
    }

    checkUsername() {
        this.notFound = false
        this.error = null

        if (!this.username) {
            return
        }

        this.SharedMoments.checkContributor(this.username)
            .then((response) => {
                const {
                    contributor
                } = response.data

                if (contributor) {
                    this.$state.go('home.contributor.step2', {
                        username: this.username
                    })
                } else {
                    this.notFound = true
                }
            })
            .catch((err) => {
                console.log('Error occured in method checkContributor', err)

                this.error = err.data
            })
    }

    watchLanguage() {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }
}

Step1Controller.$inject = ['$scope', '$state', 'SharedMoments']

export default Step1Controller



// WEBPACK FOOTER //
// ./client/app/components/home/contributor/step1/step1.controller.js